import React from 'react';

export const LadderIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="22"
            version="1.1"
            viewBox="0 0 5.821 5.821"
        >
            <g fill="#fff" fillOpacity="1">
                <path strokeWidth="0.529" d="M0 4.498H1.852V5.027H0z"></path>
                <path
                    stroke="none"
                    strokeLinecap="butt"
                    strokeLinejoin="miter"
                    strokeOpacity="1"
                    strokeWidth="0.265"
                    d="M3.969 2.117l1.323.793-1.323.794z"
                ></path>
                <path
                    stroke="none"
                    strokeLinecap="butt"
                    strokeLinejoin="miter"
                    strokeOpacity="1"
                    strokeWidth="0.265"
                    d="M4.498.265l1.323.793-1.323.794z"
                ></path>
                <path
                    stroke="none"
                    strokeLinecap="butt"
                    strokeLinejoin="miter"
                    strokeOpacity="1"
                    strokeWidth="0.265"
                    d="M3.44 3.969l1.323.794-1.323.793z"
                ></path>
                <path
                    strokeWidth="0.529"
                    d="M2.646 0.794H5.026999999999999V1.323H2.646z"
                ></path>
                <path
                    strokeWidth="0.529"
                    d="M2.117 4.498H3.9690000000000003V5.027H2.117z"
                ></path>
                <path
                    strokeWidth="0.529"
                    d="M1.323 2.646H1.8519999999999999V4.763H1.323z"
                ></path>
                <path
                    strokeWidth="0.529"
                    d="M1.588 2.646H2.911V3.175H1.588z"
                ></path>
                <path
                    strokeWidth="0.529"
                    d="M3.175 2.646H4.233V3.175H3.175z"
                ></path>
                <path
                    strokeWidth="0.529"
                    d="M2.381 0.794H2.9099999999999997V2.911H2.381z"
                ></path>
            </g>
        </svg>
    );
};
